<template>
    <main class="training-component-box">
        <p class="page-title">{{msg}}</p>
    </main>
</template>

<script>
    export default {
        name: 'training-component-box',
                data () {
            return {
                msg: 'Обучение'
            }
        }
    }
</script>


<style scoped>
    body{
        border: 2px solid blue;
        }
</style>
